import { CollectionFunctionGroup } from 'data/collectionFunctionGroup/collectionFunctionGroup.types';
import { EWarrant } from 'data/eWarrant/eWarrant.types';

/**
 * Finds the LEA an e-warrant belongs to. LEAs are collection function groups, and each
 * one carries the HI-1 sender identifier it receives e-warrants from in hi1endpointid —
 * the same SENDERID the e-warrant's authorisation was keyed with.
 *
 * Returns undefined when the e-warrant carries no sender, or when no LEA claims it.
 */
export default function findLeaForEWarrant(
  eWarrant: EWarrant,
  collectionFunctionGroupList: CollectionFunctionGroup[],
): CollectionFunctionGroup | undefined {
  const senderId = eWarrant.authorisation?.SENDERID;

  if (!senderId) {
    return undefined;
  }

  return (collectionFunctionGroupList ?? []).find(({ hi1endpointid }) => hi1endpointid === senderId);
}
